import { Col, Dropdown, Menu, Row } from "antd"
import React, { ReactElement, useEffect } from "react"
import { useSelector } from "react-redux"
import styles from './Diagnosis.module.css'

export const ImageFileViewRef = (props: { 
  imgFilelist: any[],
  onLookFile: (fileLink: any, fileName: string) => void, 
}): ReactElement => {
  return (
    <div className={styles.historyContainer}>
      {props.imgFilelist?.map((item: any, index) => (
        <div key={index} className={styles.historyItem}>
          <div className={styles.itemHeader}>
            <span className={styles.diseaseName}>
              {item?.disease?.split("/")[0]}
            </span>
            <span className={styles.createDate}>
              {item?.createTime?.split(" ")[0]}
            </span>
          </div>
          <div className={styles.imageGrid}>
            {item?.fileList?.map((file: any, fIdx: number) =>
              file?.data ? (
                <div 
                  key={fIdx} 
                  className={styles.imageWrapper} 
                  onClick={() => {
                    props.onLookFile(file?.fileLink, file?.fileName)
                  }}
                >
                  <img
                    src={`data:image/png;base64,${file?.data}`}
                    alt={file?.fileName}
                    style={{ width: '100px', height: "100px", objectFit: "cover" }}
                  />
                  <div className={styles.imageFooter}>{file.fileName}</div>
                </div>
              ) : (
                <div key={fIdx} className={styles.emptyFileWrapper}>
                  <Row gutter={8} style={{ width: "100%" }} align="middle">
                    <Col flex="auto" style={{ overflow: "hidden" }}>
                      <span
                        style={{
                          display: "block",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          verticalAlign: "middle",
                        }}
                      >
                        {file?.fileName}
                      </span>
                    </Col>
                    <Col flex="none">
                      <a
                        onClick={() => {
                          props.onLookFile(file?.fileLink, file?.fileName)
                        }}
                      >
                        查看
                      </a>
                    </Col>
                  </Row>
                </div>
              ),
            )}
          </div>
        </div>
      ))}
    </div>
  )
}
